import { render, staticRenderFns } from "./index_v1.vue?vue&type=template&id=3f2614aa&scoped=true&"
import script from "./index_v1.vue?vue&type=script&lang=js&"
export * from "./index_v1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2614aa",
  null
  
)

export default component.exports